<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataRentObjects")
    h1.title Sortierung im Buchungskalender
    .sub-headline Hier können Sie die Sortierung der Mietobjekte im Buchungskalender manipulieren.

    .card.margin-top
      #main
        b-table(
                :data="rentObjects"
                default-sort-direction="adminSortOrder"
                draggable
                @dragstart="dragstart"
                @drop="drop"
                @dragover="dragover"
                @dragleave="dragleave"
              )
          b-table-column(field='code', :id.native="'test'", label='Code' width='40', centered, v-slot="props")
            b-tag(type="is-light")
              b {{ props.row.code }}
          b-table-column(field='rentObjectType.name' label='Typ' width='40', v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObjectType.icon")
              p.icon-name {{props.row.rentObjectType.name}}
          b-table-column(field='name' label='Titel', v-slot="props")
            | {{ props.row.name }}
          b-table-column(field='street' label='Adresse', v-slot="props")
            | {{ props.row.street }} {{ props.row.city }}
          b-table-column(label='Webseite', v-slot="props")
            b-icon(v-if="props.row.activeWebsite" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
          b-table-column(label='Admin', v-slot="props")
            b-icon(v-if="props.row.activeAdmin" icon="check" type="is-success")
            b-icon(v-else icon="close" type="is-danger")
</template>

<script> 
export default {
  data() {
    return {
      draggingRow: null,
      draggingRowIndex: null,
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    }
  },
  methods: {
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      await this.$store.dispatch("rentObjects/updateOrder", {
        id: this.rentObjects[this.draggingRowIndex].id,
        position: droppedOnRowIndex
      });
      await this.$store.dispatch("rentObjects/findAll", {
        id: this.id,
      });
      this.$buefy.toast.open(`Verschoben von Position ${this.draggingRowIndex + 1} auf ${droppedOnRowIndex + 1}`)
    }
  },
  mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.$store.dispatch("rentObjectTypes/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>